"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var Label =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Label, _PureComponent);

  function Label() {
    (0, _classCallCheck2["default"])(this, Label);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Label).apply(this, arguments));
  }

  (0, _createClass2["default"])(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          size = _this$props.size,
          text = _this$props.text,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "type", "size", "text"]);
      return _react["default"].createElement("span", (0, _extends2["default"])({
        className: (0, _emotion.cx)('label', "label-".concat(type), (0, _defineProperty2["default"])({}, "label-".concat(size), size), className)
      }, rest), text);
    }
  }]);
  return Label;
}(_react.PureComponent);

exports["default"] = Label;
Label.propTypes = {
  type: _propTypes["default"].oneOf(['default', 'primary', 'success', 'warning', 'danger', 'info']),
  size: _propTypes["default"].oneOf(['sm', 'lg']),
  text: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
Label.defaultProps = {
  type: 'default'
};